import { FetchStatus } from '@powdr/constants';

import { TRAILS_PENDING, TRAILS_SUCCESS, TRAILS_ERROR } from '../types';

const initialState = {
  data: null,
  status: FetchStatus.IDLE,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TRAILS_PENDING:
      return {
        ...state,
        status: FetchStatus.LOADING,
      };
    case TRAILS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FetchStatus.SUCCESS,
      };
    case TRAILS_ERROR:
      return {
        status: FetchStatus.ERROR,
        error: action.payload,
      };
    default: return state;
  }
};
